// pind · 我的作品（IndexedDB，仅存在本机浏览器）
// 记录：{ id, name, cols, rows, beads, colorCount, colors:[{code,hex,name}], thumb, createdAt, updatedAt, project, progress:{done:Uint8Array, updatedAt}|null }
const DB = 'douqu-works', STORE = 'works', VERSION = 1;
let dbp = null;

function open() {
  if (dbp) return dbp;
  dbp = new Promise((resolve, reject) => {
    if (!('indexedDB' in window)) { reject(new Error('no-idb')); return; }
    const req = indexedDB.open(DB, VERSION);
    req.onupgradeneeded = () => { const db = req.result; if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, { keyPath: 'id' }).createIndex('updatedAt', 'updatedAt'); };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbp;
}
async function tx(mode, fn) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode), s = t.objectStore(STORE); let out;
    Promise.resolve(fn(s)).then((v) => { out = v; });
    t.oncomplete = () => resolve(out); t.onerror = () => reject(t.error); t.onabort = () => reject(t.error);
  });
}
const req2p = (r) => new Promise((res, rej) => { r.onsuccess = () => res(r.result); r.onerror = () => rej(r.error); });

export const newId = () => `w${Date.now().toString(36)}${Math.random().toString(36).slice(2, 7)}`;
export async function listWorks() { const all = await tx('readonly', (s) => req2p(s.getAll())); return all.sort((a, b) => b.updatedAt - a.updatedAt); }
export async function getWork(id) { return tx('readonly', (s) => req2p(s.get(id))); }
export async function putWork(rec) { await tx('readwrite', (s) => req2p(s.put(rec))); return rec; }
export async function deleteWork(id) { await tx('readwrite', (s) => req2p(s.delete(id))); }
export async function patchWork(id, patch) {
  return tx('readwrite', async (s) => { const cur = await req2p(s.get(id)); if (!cur) return null; const next = { ...cur, ...patch }; await req2p(s.put(next)); return next; });
}
/** 保存进度（不改 updatedAt 之外的字段） */
export async function saveProgress(id, done) { return patchWork(id, { progress: { done, updatedAt: Date.now() }, updatedAt: Date.now() }); }

// —— 备份 ——
function u8ToB64(u) { let s = ''; for (let i = 0; i < u.length; i += 0x8000) s += String.fromCharCode.apply(null, u.subarray(i, i + 0x8000)); return btoa(s); }
function b64ToU8(b) { const s = atob(b), u = new Uint8Array(s.length); for (let i = 0; i < s.length; i++) u[i] = s.charCodeAt(i); return u; }

export async function exportBackup() {
  const works = (await listWorks()).map((w) => ({ ...w, progress: w.progress ? { ...w.progress, done: u8ToB64(w.progress.done) } : null }));
  return new Blob([JSON.stringify({ type: 'douqu-works-backup', version: 1, exportedAt: new Date().toISOString(), works })], { type: 'application/json' });
}
/** 导入备份：同一作品保留较新的一份。返回 {added, updated, skipped} */
export async function importBackup(text) {
  const data = JSON.parse(text);
  if (data?.type !== 'douqu-works-backup' || !Array.isArray(data.works)) throw new Error('format');
  let added = 0, updated = 0, skipped = 0;
  for (const raw of data.works) {
    if (!raw || typeof raw.id !== 'string' || !raw.project?.grid || !Number.isInteger(raw.cols) || !Number.isInteger(raw.rows)) { skipped++; continue; }
    const rec = { ...raw, progress: raw.progress && typeof raw.progress.done === 'string' ? { ...raw.progress, done: b64ToU8(raw.progress.done) } : null };
    const cur = await getWork(rec.id);
    if (!cur) { await putWork(rec); added++; } else if ((rec.updatedAt || 0) > (cur.updatedAt || 0)) { await putWork(rec); updated++; } else skipped++;
  }
  return { added, updated, skipped };
}

export function formatTime(ms) {
  const d = new Date(ms), now = new Date(), p = (n) => String(n).padStart(2, '0');
  const hm = `${p(d.getHours())}:${p(d.getMinutes())}`;
  if (d.toDateString() === now.toDateString()) return `今天 ${hm}`;
  if (d.getFullYear() === now.getFullYear()) return `${d.getMonth() + 1}月${d.getDate()}日 ${hm}`;
  return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
}
